var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcommerceDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 190,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M74.868 131.858c-8.74-1.531-17.503-41.87-1.909-58.56 6.505-6.962 13.97-6.292 19.207-15.877 4.674-8.552.803-12.872 4.397-22.777 5.055-13.931 20.444-26.701 31.327-22.879 5.46 1.921 10.673 8.322 10.999 15.757.259 5.954-5.333 10.626-4.023 12.126 1.075 1.231 4.464-1.96 6.59-.715 3.134 1.838 3.183 13.127-1.752 21.423-8.449 14.206-26.128 10.607-29.196 21.552-1.951 6.982 4.56 10.83 1.873 17.862-2.368 6.185-8.492 6.025-17.679 12.209-14.392 9.681-15.147 20.703-19.834 19.879Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.364 140.391a.448.448 0 0 1-.441-.294.483.483 0 0 1 .072-.478c.06-.275.079-1.213.097-2.279.097-6.03.362-22.042 8.455-45.719C93.73 61.844 112.363 31.141 138.925.367a.431.431 0 0 1 .629-.031.492.492 0 0 1 .03.663C111.046 34.07 76.844 84.57 75.98 137.36c-.037 2.386-.049 2.82-.477 3.005-.049.013-.097.019-.14.026Z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.302 60.988c-.236.02-.441-.166-.465-.414-.03-.256.145-.492.386-.517 19.986-2.483 32.458-6.906 39.403-10.18 7.52-3.548 10.358-6.54 10.383-6.573a.43.43 0 0 1 .628-.006.491.491 0 0 1 .006.664c-.115.127-2.935 3.12-10.576 6.733-7.006 3.312-19.592 7.792-39.74 10.293h-.025ZM109.681 40.554a.441.441 0 0 1-.266-.07c-4.632-3.14-6.716-10.569-6.191-22.082.387-8.481 2.126-16.171 2.145-16.248.054-.249.295-.408.531-.344a.467.467 0 0 1 .326.561c-.066.3-6.77 30.244 3.666 37.315a.48.48 0 0 1-.211.868ZM82.267 97.556a.463.463 0 0 1-.356-.147c-5.901-6.758-7.393-16.477-7.605-23.446-.229-7.518.949-13.543.96-13.6a.444.444 0 0 1 .526-.364c.242.051.393.3.344.555-.011.058-1.165 5.993-.942 13.402.206 6.803 1.655 16.28 7.369 22.822a.492.492 0 0 1-.024.663.453.453 0 0 1-.272.115Z",
    opacity: 0.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M76.293 141.272c.308-18.763 3.727-32.554 6.656-41.386 2.301-6.931 6.173-16.466 11.234-16.587 2.422-.057 3.346 2.087 5.901 1.908 4.826-.338 6.39-8.322 10.467-13.44 6.982-8.756 24.382-12.948 34.42-4.435 12.079 10.25 8.443 34.66-.417 40.358-5.254 3.376-12.756.454-13.849 3.549-1.105 3.114 6.281 6.688 5.738 11.972-.562 5.469-9.187 8.52-9.712 8.698-10.425 3.555-16.422-4.078-27.088-3.816-5.792.141-13.819 2.623-23.35 13.179Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFDFE",
    d: "m71.329 155.337.26.07c10.575-42.586 43.908-73.92 89.175-83.831l-.054-.281c-21.453 4.697-40.961 14.608-56.411 28.66-16.247 14.781-27.643 33.926-32.97 55.382Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFDFE",
    d: "M72.023 90.121c5.605 10.486 9.24 29.235 8.111 41.789l.272.025c1.135-12.604-2.519-31.43-8.142-41.96l-.241.146ZM73.49 147.002l.23.147c3.177-5.635 8.927-9.349 17.087-11.053 5.985-1.251 13.106-1.404 21.157-.46l.03-.287c-8.081-.944-15.232-.791-21.242.466-8.232 1.717-14.042 5.482-17.261 11.187ZM106.564 98.054l.224.16c6.505-10.294 6.305-23.307 4.995-32.407l-.266.044c1.305 9.05 1.504 21.986-4.953 32.203ZM129.08 82.668l.073.274c12.719-3.708 25.572 1.742 32.101 5.322l.126-.255c-6.571-3.6-19.496-9.075-32.3-5.341Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M81.289 62.398c-.574 0-1.07-.497-1.124-1.161-.99-11.775-4.372-22.962-9.524-31.5-4.566-7.563-10.002-12.081-14.538-12.081h-.018c-16.537.038-19.997 43.128-20.034 43.562-.054.702-.598 1.225-1.22 1.168-.622-.064-1.08-.683-1.026-1.385.139-1.87 3.684-45.866 22.274-45.91h.018c5.363 0 11.343 4.805 16.404 13.19 5.363 8.89 8.884 20.505 9.911 32.7.06.703-.399 1.328-1.015 1.398a.325.325 0 0 1-.108.02Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m12.388 151.087 21.773 12.508 13.19-45.943-21.736-61.584-6.161 1.717-9.35 88.452c-.217 1.997.695 3.937 2.284 4.85Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M47.351 117.659 25.614 56.068l-3.636 1.015c-.501 8.226-.284 14.99.06 19.917 1.456 20.97 6.294 26.804 3.95 41.431-1.95 12.164-6.202 13.817-5.834 21.998.405 8.915 5.883 16.376 12.394 22.247l1.606.925 13.197-45.942Z",
    opacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "m25.614 56.068 81.983 4.716 26.055 93.711-99.492 9.1-8.546-107.527Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "m107.597 60.784-42.754-2.457c-.72 1.2-1.68 3.153-1.855 5.642-1.05 14.735 27.722 19.503 30.295 37.589 1.963 13.772-10.11 29.656-20.885 36.734-11.354 7.46-19.043 3.682-26.72 11.959-3.376 3.638-5.43 8.188-6.65 12.904l94.625-8.66-26.056-93.71Z",
    opacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M50.758 64.504c-.513 0-.978-.395-1.1-.989-.229-1.117-5.562-27.492 1.958-40.435 2.156-3.708 5.164-5.973 8.95-6.733 19.442-3.886 31.407 43.499 31.908 45.515.17.683-.18 1.392-.779 1.583-.598.192-1.226-.204-1.395-.887-.115-.472-11.898-47.18-29.34-43.683-3.196.638-5.63 2.476-7.46 5.616-6.988 12.03-1.697 38.176-1.643 38.437.145.69-.235 1.379-.84 1.538a.884.884 0 0 1-.259.038Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M50.77 68.276c1.741 0 3.153-1.602 3.153-3.58 0-1.977-1.412-3.58-3.153-3.58s-3.153 1.603-3.153 3.58c0 1.978 1.412 3.58 3.153 3.58Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M91.918 67.944c1.741 0 3.153-1.603 3.153-3.58s-1.412-3.58-3.153-3.58c-1.74 0-3.152 1.603-3.152 3.58s1.411 3.58 3.152 3.58Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8DEE8",
    d: "m113.872 105.878-25.45-26.223c-.538-.555-1.305-.708-1.976-.395l-13.583 6.266c-1.148.53-1.54 2.145-.797 3.268l22.171 33.536c.61.926 1.764 1.13 2.597.46l16.869-13.581c.979-.797 1.063-2.412.169-3.331ZM84.767 88.871c-.858.657-2.21.076-3.02-1.29-.81-1.365-.773-3.005.085-3.663.857-.657 2.21-.076 3.02 1.29.809 1.371.773 3.012-.085 3.663Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F7FA",
    d: "m113.872 105.521-25.45-26.223c-.538-.555-1.305-.709-1.976-.396L72.863 85.17c-1.148.53-1.54 2.144-.797 3.267l22.171 33.537c.61.925 1.764 1.13 2.597.459l16.869-13.58c.979-.798 1.063-2.412.169-3.331ZM84.767 88.513c-.858.657-2.21.077-3.02-1.289-.81-1.366-.773-3.006.085-3.663.857-.658 2.21-.077 3.02 1.289.809 1.372.773 3.006-.085 3.663Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#26264F",
    d: "M79.477 82.074a.217.217 0 0 1-.193-.134c-.882-2.195-2.072-4.09-3.534-5.642-4.01-4.237-9.192-4.901-14.199-5.546-4.983-.638-9.694-1.244-12.502-5.437-.713-1.06-1.818-2.98-1.226-3.9.236-.37.713-.542 1.413-.503a.216.216 0 0 1 .2.23c-.007.12-.103.216-.218.21-.374-.02-.858.02-1.045.313-.314.491.163 1.825 1.22 3.395 2.706 4.033 7.326 4.627 12.213 5.252 5.079.651 10.333 1.328 14.446 5.667 1.504 1.583 2.724 3.53 3.624 5.782.043.115-.006.243-.108.287a.178.178 0 0 1-.091.026Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#26264F",
    d: "M81.65 86.509a.204.204 0 0 1-.15-.064.237.237 0 0 1 0-.313c.017-.019 1.757-1.882 1.75-4.365-.005-1.525-.664-2.98-1.956-4.32-2.736-2.84-10.002-6.133-16.416-9.037-3.914-1.774-7.61-3.446-10.032-4.888a22.79 22.79 0 0 0-1.733-.926.228.228 0 0 1-.103-.293c.048-.109.17-.16.278-.109.61.294 1.202.606 1.764.938 2.41 1.43 6.093 3.102 9.995 4.87 6.445 2.916 13.746 6.228 16.543 9.126 1.377 1.43 2.072 2.986 2.078 4.64.006 2.673-1.8 4.594-1.873 4.677a.182.182 0 0 1-.145.064Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m113.872 105.521-25.45-26.223c-.538-.555-1.305-.709-1.976-.396l-1.208.555a19.237 19.237 0 0 0 1.51 3.989c3.763 7.288 9.93 6.969 11.355 12.023 1.262 4.48-2.972 6.886-3.533 13.172-.278 3.14.356 7.32 3.768 12.573l15.359-12.368c.985-.792 1.069-2.406.175-3.325Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8DEE8",
    d: "M94.443 115.132c-.338 0-.676-.198-.864-.549-.29-.543-.138-1.245.339-1.577l12.26-8.443c.477-.325 1.099-.153 1.389.383.29.543.139 1.245-.338 1.577l-12.26 8.443a.954.954 0 0 1-.526.166Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "m86.972 164.527 31.43 2.335V118.22l-31.43 2.336v43.971Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "m118.403 166.862 23.609-3.331v-42.203l-23.609-3.108v48.642Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M107.277 119.05v19.733H96.744v-18.954l10.533-.779Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M131.612 143.409c-1.069-6.037-5.128-9.075-5.895-17.026a26.476 26.476 0 0 1 .302-7.154l15.987 2.106v42.209l-19.544 2.757c8.703-10.211 10.086-17.614 9.15-22.892Z",
    opacity: 0.71
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M22.564 80.05a5.2 5.2 0 0 1-1.788-1.563c-.652-.913-1.34-2.527-.803-3.197.26-.32.616-.192 1.36-.326 1.551-.28 1.968-1.193 2.965-1.563 2.186-.824 5.478 1.582 5.309 2.801-.073.51-.743.81-1.975 1.372-1.269.575-1.776.505-2.84.977-.555.249-1.352.689-2.228 1.5Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "m2.035 152.223-.211-.39s-.38-.242-.562.256c-.18.497-1.208 3.114-1.262 4.294.272.709 1.033.109 1.19-.376.157-.485.7-2.272.7-2.272l.145-1.512Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M4.457 154.086c-.32-.006-.634 0-.954-.019a27.34 27.34 0 0 1-1.757-.134c.096-.645.199-1.296.296-1.94.302-.122.591-.243.881-.364.145-.064.284-.128.43-.185.132-.058.27-.115.404-.179.193-.089.38-.172.568-.261.072-.032.15-.071.223-.103.217-.102.435-.21.646-.312.037-.019.073-.039.109-.051.23-.115.453-.23.67-.345.019-.006.03-.019.049-.025.23-.122.453-.243.676-.364 0 0 .006-.007.012-.007.447-.249.87-.497 1.269-.74 4.976-3.07 6.62-6.19 7.126-8.647 1.426-6.899-5.556-11.334-3.756-18.82 1.359-5.642 7.096-10.473 10.63-9.343 3.992 1.27 4.614 9.445 5 14.474.435 5.66.919 11.972-2.512 17.62-3.243 5.348-9.108 8.641-15.854 9.522-.163.019-.326.031-.49.051-.392.044-.779.089-1.177.115-.181.012-.369.012-.55.025-.386.019-.773.045-1.165.045-.254.006-.514-.007-.774-.013Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M4.457 154.086c-.32-.006-.634 0-.954-.019a27.34 27.34 0 0 1-1.757-.134c.096-.645.199-1.296.296-1.94.302-.122.591-.243.881-.364.145-.064.284-.128.43-.185.132-.058.27-.115.404-.179.193-.089.38-.172.568-.261.072-.032.15-.071.223-.103.217-.102.435-.21.646-.312.037-.019.073-.039.109-.051.23-.115.453-.23.67-.345.019-.006.03-.019.049-.025.23-.122.453-.243.676-.364 0 0 .006-.007.012-.007.447-.249.87-.497 1.269-.74 4.976-3.07 6.62-6.19 7.126-8.647 1.426-6.899-5.556-11.334-3.756-18.82 1.359-5.642 7.096-10.473 10.63-9.343 3.992 1.27 4.614 9.445 5 14.474.435 5.66.919 11.972-2.512 17.62-3.243 5.348-9.108 8.641-15.854 9.522-.163.019-.326.031-.49.051-.392.044-.779.089-1.177.115-.181.012-.369.012-.55.025-.386.019-.773.045-1.165.045-.254.006-.514-.007-.774-.013Z",
    opacity: 0.25
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M36.952 113.97c.76-1.276-2.797-3.165-3.95-8.411-.979-4.429 1.014-5.552-.073-11.488-.604-3.305-1.637-5.22-2.845-6.617-.99-1.15-2.283-2.643-3.442-2.445-3.642.613-7.96 18.125-.677 25.764 3.739 3.924 10.063 4.741 10.987 3.197Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M17.824 169.422c.163-.402 1.075.612 1.927 1.685l-.327 4.626c.302-.204.683-.421 1.112-.529.513-.128 1.407.07 1.473.331.423 1.609-3.37 1.96-3.786 1.456-.417-.505-.32-1.098-.32-1.098.386-2.317.332-3.887.15-4.972-.132-.759-.326-1.276-.23-1.499Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M8.1 117.684c2.168-3.376 4.276-6.784 6.39-10.192.417-.67.658-1.448.773-2.259a15.39 15.39 0 0 1 2.386 2.534c.598 3.159 1.516 7.9 2.73 13.65 3.086 14.615 4.384 18.272 5.037 22.873 1.008 7.071.652 17.492-5.998 31.449-.507.051-1.014.109-1.522.16-1.069-11.934-2.295-22.713-2.91-28.246-.212-1.876-.828-7.511-3.685-12.055-.048-.07-4.27-6.178-5.732-8.616a42.649 42.649 0 0 1-1.781-3.274c1.636-1.825 2.953-3.905 4.312-6.024Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M8.1 117.684c2.162-3.376 4.276-6.784 6.39-10.192.416-.67.658-1.448.773-2.259a15.39 15.39 0 0 1 2.385 2.534c.943 3.861 1.619 7.16 2.09 9.681 1.305 7.001 1.232 8.934.296 10.677-1.286 2.387-2.772 1.742-3.708 3.822-1.65 3.644 2.766 6.14 2.724 13.172-.025 3.9-1.341 4.876-.743 8.456.157.926.592 2.955.398 5.744-.084 1.225-.18.957-.247 2.061-.2 3.153.507 6.05.199 8.016a4.633 4.633 0 0 1-.429 1.378 4.18 4.18 0 0 1-.713 1.041c-.966-10.275-1.993-19.273-2.536-24.175-.211-1.876-.828-7.511-3.684-12.055-.049-.07-4.27-6.178-5.732-8.615a43.04 43.04 0 0 1-1.782-3.274c1.643-1.813 2.96-3.893 4.319-6.012Z",
    opacity: 0.25
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M30.507 88.187c1.36 2.636 1.208 5.265 1.057 6.414-.447 3.459-2.361 5.763-3.001 6.631-2.15 2.923-3.83 8.698-1.16 21.366-1.498-.255-3.968-.498-6.837.134-7.308 1.608-10.231 7.346-13.734 6.299-1.293-.383-3.056-1.812-4.282-7.129-1.07-2.763-4.41-12.367-.99-23.65a34.403 34.403 0 0 1 9.494-15.227c2.005-.715 8.268-2.643 14.229.408 1.486.753 3.787 1.978 5.224 4.754Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "m23.664 104.544 5.593-2.087a.362.362 0 0 0 .223-.223l.924-2.668c.097-.274-.133-.555-.404-.491l-5.255 1.199c-.12.026-.386.109-.471.345l-1.039 3.248c-.096.294.151.773.429.677Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "m23.749 104.576 5.405-1.825a.362.362 0 0 0 .224-.223l.924-2.668c.096-.275-.133-.555-.405-.492l-5.255 1.2a.366.366 0 0 0-.26.243l-1.074 3.293c-.097.287.163.568.44.472Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "m21.297 102.795.604-.306s.948-.734 1.588-1.034c.64-.293 1.154-.223 1.552.396.399.625-.277 1.212-.851 1.729-.35.313-1.081.345-1.673.307-.417-.026-1.25.28-1.25.28l.03-1.372ZM22.444 77.734c0 .555-.018 3.542-1.274 4.033-.272.109-.496.039-1.71.07-.694.02-1.256.058-1.618.09.06.51.181 1.193.44 1.96 1.565 4.639 6.614 7.868 8.33 6.707.893-.607.96-2.42.99-3.172a6.677 6.677 0 0 0-.405-2.54 147.02 147.02 0 0 0-1.926-1.449c-.43-.313-.852-.625-1.28-.925.03-.568.054-1.143.084-1.71l-1.631-3.064Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC9A",
    d: "M21.894 78.838s-.006 2.457 1.848 3.255c1.661.715 3.842-3.408 3.183-4.742-.217-.447-.875-.97-1.51-1.091-.447-.083-2.3-.096-2.826 1.442-.157-.485-.465-.804-.791-.804-.049 0-.2.02-.314.108-.423.32-.302 1.066.41 1.832Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M1.559 98.252A34.463 34.463 0 0 1 9.235 84.85c2.827 1.972 5.696 4.646 5.454 7.511-.272 3.261-4.397 4.608-4.01 6.67.555 2.986 9.536 1.856 10.587 5.143 1.232 3.874-9.41 11.168-8.842 11.991.405.594 5.303-3.58 10.866-2.61 1.08.192 2.047.632 2.905 1.219.199 2.266.58 4.857 1.207 7.824-1.497-.255-3.968-.497-6.836.134-7.308 1.609-10.232 7.346-13.735 6.299-1.292-.383-3.056-1.812-4.282-7.128-1.075-2.764-4.415-12.362-.99-23.651Z",
    opacity: 0.3
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M15.027 83.241c-1.697-.446-1.703-1.027-3.974-.223-6.516 2.317-13.414 12.713-9.85 20.052 1.98 4.084 6.734 7.76 11.976 6.911 4.264-.689 6.77-4.046 7.405-4.958l.743-3.134c-2.778 1.666-4.735 1.666-6.052 1.302-2.235-.613-2.73-2.304-6.42-3.784-1.438-.575-2.301-.696-2.343-1.175-.091-.989 3.52-1.32 5.804-3.388 1.654-1.5 3.316-4.583 2.711-11.603Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M97.656 177.565c0 1.755 1.02 3.178 2.283 3.178 1.262 0 2.283-1.423 2.283-3.178s-1.021-3.179-2.283-3.179-2.283 1.424-2.283 3.179Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M97.016 177.922c0 1.755 1.02 3.178 2.283 3.178 1.262 0 2.283-1.423 2.283-3.178s-1.021-3.178-2.283-3.178-2.283 1.43-2.283 3.178Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M98.345 177.986c0 .734.429 1.334.96 1.334.532 0 .961-.594.961-1.334 0-.734-.429-1.334-.96-1.334-.532.007-.96.6-.96 1.334Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C2",
    d: "M99.94 174.048v3.491c0 .511-.393.925-.877.925a.854.854 0 0 1-.706-.382l-2.972-4.295 4.554.261Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M73.183 174.783c0 1.755 1.02 3.178 2.283 3.178 1.262 0 2.283-1.423 2.283-3.178s-1.02-3.179-2.283-3.179c-1.256 0-2.283 1.424-2.283 3.179Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M72.55 175.14c0 1.755 1.02 3.178 2.282 3.178 1.263 0 2.283-1.423 2.283-3.178s-1.02-3.179-2.283-3.179c-1.262 0-2.283 1.424-2.283 3.179Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M73.878 175.204c0 .734.429 1.333.96 1.333.532 0 .96-.593.96-1.333 0-.741-.428-1.334-.96-1.334-.531 0-.96.6-.96 1.334Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C2",
    d: "M75.472 171.26v3.491c0 .51-.392.925-.875.925a.853.853 0 0 1-.707-.383l-2.972-4.295 4.554.262Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M100.284 174.591a.604.604 0 0 0 .592-.562c.036-.344-.2-.664-.532-.702l-28.978-3.452c-1.577-.288-2.893-1.551-3.316-3.223l-12.14-47.755c-.646-2.54-2.748-4.372-5.236-4.557l-8.812-.555c-.333-.026-.616.242-.635.593-.018.351.23.651.562.67l8.812.556c1.97.14 3.642 1.595 4.155 3.618l12.14 47.755c.544 2.145 2.235 3.772 4.306 4.148l29.015 3.453c.018.013.042.013.067.013Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80.123 155.79c.26 0 .501-.179.574-.46l6.825-25.233c.09-.339-.09-.69-.41-.785a.6.6 0 0 0-.744.434l-6.825 25.233c-.09.339.09.69.411.785.054.02.115.026.17.026ZM73.14 154.737a.616.616 0 0 0 .593-.523l4.21-24.991a.628.628 0 0 0-.484-.734.597.597 0 0 0-.694.51l-4.21 24.991a.629.629 0 0 0 .586.747ZM68.805 153.914h.024c.332-.013.586-.313.574-.658l-.973-24.729c-.012-.351-.278-.626-.622-.606-.332.012-.586.312-.574.657l.973 24.729a.61.61 0 0 0 .598.607ZM89.642 156.715a.602.602 0 0 0 .567-.434l8.015-25.24a.65.65 0 0 0-.38-.804c-.314-.108-.653.07-.761.402l-8.009 25.24a.65.65 0 0 0 .38.805c.06.019.127.031.188.031Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M21.242 117.257c.03 0 .067 0 .103-.007l19.72-1.71c.658-.058 1.153-.67 1.099-1.366-.055-.696-.634-1.219-1.293-1.161l-19.72 1.71c-.658.057-1.153.67-1.099 1.366.049.663.574 1.168 1.19 1.168Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M76.185 186.231c0 1.755 1.02 3.179 2.283 3.179 1.262 0 2.283-1.424 2.283-3.179s-1.02-3.178-2.283-3.178c-1.256 0-2.283 1.423-2.283 3.178Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M75.552 186.589c0 1.755 1.02 3.178 2.283 3.178 1.262 0 2.283-1.423 2.283-3.178s-1.02-3.179-2.283-3.179c-1.262 0-2.283 1.424-2.283 3.179Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M76.88 186.653c0 .734.428 1.333.96 1.333.531 0 .96-.593.96-1.333 0-.734-.429-1.334-.96-1.334-.532.006-.96.6-.96 1.334Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DBE2",
    d: "M78.474 182.715v3.491c0 .51-.392.925-.875.925a.853.853 0 0 1-.707-.383l-2.972-4.295 4.554.262Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M54.998 183.991c0 1.755 1.02 3.178 2.283 3.178 1.262 0 2.283-1.423 2.283-3.178s-1.02-3.178-2.283-3.178c-1.256 0-2.283 1.423-2.283 3.178Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M54.363 184.349c0 1.755 1.021 3.178 2.283 3.178 1.263 0 2.283-1.423 2.283-3.178s-1.02-3.179-2.283-3.179c-1.262 0-2.283 1.424-2.283 3.179Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M55.693 184.413c0 .734.429 1.333.96 1.333.532 0 .96-.593.96-1.333 0-.734-.428-1.334-.96-1.334-.531 0-.96.6-.96 1.334Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DBE2",
    d: "M57.287 180.468v3.491c0 .511-.392.926-.875.926a.855.855 0 0 1-.707-.383l-2.972-4.295 4.554.261Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M109.301 132.05c.314 0 .574-.256.598-.587.024-.351-.224-.651-.556-.677l-51.609-3.925c-.048 0-.096 0-.145.007l-21.368 3.848c-.326.057-.544.383-.49.734a.604.604 0 0 0 .695.517l21.296-3.836 51.537 3.919h.042Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DBE2",
    d: "M91.761 137.679a.56.56 0 0 0 .176-.026l17.539-5.629c.314-.102.495-.453.399-.791-.097-.332-.435-.523-.749-.421l-17.425 5.59-55.323-5.692c-.333-.039-.623.223-.653.568-.03.351.212.657.538.689l55.444 5.705c.012 0 .036.007.055.007Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C2",
    d: "M42.997 157.583c.03 0 .06 0 .09-.006l21.025-3.408 31.986 3.255a.607.607 0 0 0 .652-.568c.03-.351-.211-.657-.537-.689l-32.059-3.261a.389.389 0 0 0-.151.006l-21.097 3.421c-.326.051-.55.376-.501.721a.608.608 0 0 0 .592.529Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DBE2",
    d: "M81.12 161.413c.229 0 .44-.141.543-.364l10.642-23.734c.139-.319.012-.696-.284-.842a.589.589 0 0 0-.797.3l-10.461 23.331-37.706-3.79a.607.607 0 0 0-.652.568c-.03.351.211.657.537.689l38.123 3.829c.012.013.036.013.054.013Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DBE2",
    d: "M81.12 161.412a.555.555 0 0 0 .145-.019l15.039-3.988a.594.594 0 0 0 .38-.313l13.142-25.374a.658.658 0 0 0-.235-.862.587.587 0 0 0-.815.249L95.76 156.237l-14.785 3.925c-.32.083-.514.427-.435.765a.6.6 0 0 0 .58.485Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DBE2",
    d: "M87.89 146.307a.523.523 0 0 0 .169-.026l16.519-5.118c.32-.096.501-.453.404-.785a.59.59 0 0 0-.743-.428l-16.41 5.08-48.77-4.493c-.338-.031-.622.23-.646.575-.03.351.217.657.543.683l48.885 4.505c.013.007.03.007.049.007ZM83.856 155.305a.488.488 0 0 0 .163-.026l15.824-4.684a.638.638 0 0 0 .417-.778c-.091-.339-.423-.537-.737-.441l-15.715 4.653-42.35-3.913c-.327-.038-.623.23-.647.575-.03.351.218.657.544.683l42.459 3.924c.006.007.024.007.042.007Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DBE2",
    d: "M73.335 160.627c.26 0 .495-.178.573-.453l6.789-24.059c.097-.338-.085-.689-.405-.785-.314-.102-.652.089-.743.428l-6.788 24.059c-.097.338.084.689.404.785a.499.499 0 0 0 .17.025ZM65.828 159.874a.617.617 0 0 0 .591-.523l4.071-24.379c.055-.344-.163-.67-.483-.733-.326-.058-.634.172-.695.51l-4.07 24.379c-.055.344.163.67.483.734.03.012.066.012.103.012ZM57.36 158.854c.313 0 .58-.262.597-.6l1.28-24.207c.019-.351-.235-.65-.567-.67a.62.62 0 0 0-.634.6l-1.28 24.207c-.019.351.235.65.567.67h.036ZM49.333 157.909h.03c.332-.019.586-.319.568-.664l-1.22-24.589c-.018-.351-.296-.619-.628-.6-.332.019-.586.319-.568.664l1.22 24.589c.018.338.284.6.598.6ZM85.668 160.207a.61.61 0 0 0 .543-.358l10.968-24.091c.145-.313.019-.696-.277-.842a.58.58 0 0 0-.798.293L85.136 159.3c-.145.313-.018.696.278.843a.499.499 0 0 0 .254.064ZM91.762 158.585a.595.595 0 0 0 .537-.351l11.645-24.646a.645.645 0 0 0-.266-.849.58.58 0 0 0-.803.281L91.23 157.666c-.15.313-.03.696.266.849.085.051.175.07.266.07Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DBE2",
    d: "M78.59 183.685a.538.538 0 0 0 .223-.045l21.694-9.1c.308-.128.459-.498.339-.823a.592.592 0 0 0-.779-.358l-21.556 9.05-26.17-3.376c-1.86-.243-3.388-1.634-3.89-3.542L34.107 120.46c-.652-2.514-2.748-4.326-5.206-4.512l-7.61-.58a.617.617 0 0 0-.64.587c-.025.351.223.651.555.676l7.61.581c1.957.147 3.618 1.589 4.137 3.587l14.345 55.03c.628 2.406 2.548 4.161 4.898 4.461l26.32 3.395h.073Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M35.127 113.772c.187-.006 2.826-.082 3.08.741.073.236.006.466.006.466-.139.491-.718.663-.803.682.888.6 1.957.441 2.47-.229.356-.466.46-1.206.175-1.781-.26-.529-.76-.734-1.038-.829-1.976-.677-3.89.95-3.89.95Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 120.587,
    x2: 76.04,
    y1: 25.492,
    y2: 134.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 126.759,
    x2: 83.538,
    y1: 89.212,
    y2: 134.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 14.236,
    x2: 54.103,
    y1: 41.243,
    y2: 39.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 10.069,
    x2: 47.349,
    y1: 109.831,
    y2: 109.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 20.134,
    x2: 47.349,
    y1: 109.831,
    y2: 109.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 65.813,
    x2: 136.358,
    y1: 103.171,
    y2: 215.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 65.623,
    x2: 123.433,
    y1: 92.885,
    y2: 221.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 75.346,
    x2: 56.028,
    y1: 3.072,
    y2: 159.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 84.468,
    x2: 29.863,
    y1: -3.045,
    y2: 95.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 116.062,
    x2: 61.457,
    y1: 15.835,
    y2: 114.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 91.367,
    x2: 124.277,
    y1: 121.172,
    y2: 173.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#FBA94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 117.679,
    x2: 147.653,
    y1: 121.738,
    y2: 169.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#FBA94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 29.61,
    x2: 19.78,
    y1: 76.644,
    y2: 76.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 13.484,
    x2: -6.056,
    y1: 145.298,
    y2: 157.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 30.84,
    x2: 14.15,
    y1: 140.906,
    y2: 134.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 30.84,
    x2: 14.15,
    y1: 140.906,
    y2: 134.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 40.794,
    x2: 26.354,
    y1: 90.25,
    y2: 103.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 21.111,
    x2: 17.159,
    y1: 165.038,
    y2: 187.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 22.868,
    x2: 11.173,
    y1: 126.317,
    y2: 148.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 18.026,
    x2: 10.443,
    y1: 122.266,
    y2: 146.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 25.273,
    x2: -14.265,
    y1: 99.028,
    y2: 121.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 24.261,
    x2: 25.992,
    y1: 96.988,
    y2: 99.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 25.59,
    x2: 29.947,
    y1: 105.377,
    y2: 94.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 26.139,
    x2: -14.457,
    y1: 98.832,
    y2: 121.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 15.659,
    x2: -4.93,
    y1: 94.463,
    y2: 106.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 102.41,
    x2: 101.088,
    y1: 175.373,
    y2: 176.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 101.59,
    x2: 97.019,
    y1: 177.925,
    y2: 177.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 100.263,
    x2: 98.347,
    y1: 177.989,
    y2: 177.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 77.939,
    x2: 76.618,
    y1: 172.587,
    y2: 173.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 77.12,
    x2: 72.548,
    y1: 175.139,
    y2: 175.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 75.792,
    x2: 73.876,
    y1: 175.204,
    y2: 175.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 42.163,
    x2: 20.044,
    y1: 115.13,
    y2: 115.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 80.941,
    x2: 79.619,
    y1: 184.037,
    y2: 185.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 80.121,
    x2: 75.55,
    y1: 186.59,
    y2: 186.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 78.793,
    x2: 76.877,
    y1: 186.654,
    y2: 186.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 59.755,
    x2: 58.433,
    y1: 181.796,
    y2: 182.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 58.934,
    x2: 54.363,
    y1: 184.349,
    y2: 184.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 57.607,
    x2: 55.692,
    y1: 184.413,
    y2: 184.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3C3B6B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommerceDevelopment);
export default __webpack_public_path__ + "static/media/ecommerce-development.6c46985c069f01910c32f735c78c711d.svg";
export { ForwardRef as ReactComponent };